import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { ResponsesPageables } from "../../core/models/responesPageables";
import { endpointsURL } from "src/app/constants/endpointsURL";
import { CreateImgPlacaRequest, ImgPlacaRequest } from "../models/imgPlaca";

@Injectable({
  providedIn: "root",
})
export class PlacaService {
  env = environment.env;
  placaURL = endpointsURL.placaURL;
  tramitacionURL = endpointsURL.tramitacionURL;
  historicoBastidorURL = endpointsURL.historicoBastidorURL;

  constructor(private httpClient: HttpClient) {}

  public getPlacaMailBoxList(filters: string): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.placaURL}buzon/list${filters}`
    );
  }

  public getPlaca(id: string): Observable<any> {
    //""SEAT/P0304/2017"
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(`${this.env}${this.placaURL}buzon/detail`, {
      params: params,
    });
  }

  public getPrintFields(): Observable<any> {
    return this.httpClient.get<any>(
      `${this.env}${this.placaURL}buzon/camposImpresion`
    );
  }

  public savePlacaData(data: any): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.placaURL}buzon/saveDatosPlaca`,
      data
    );
  }

  public correctPlaca(data: any, files: any[]): Observable<any> {
    const fd = new FormData();

    fd.append("updateCertificadoRequest", JSON.stringify(data));
    files.forEach((e) => {
      fd.append("files", e.blob, e.name);
    });
    if (files.length == 0) {
      fd.append("files", new Blob([], { type: "text/html" }), "empty");
    }
    return this.httpClient.put<any>(
      `${this.env}${this.placaURL}buzon/update`,
      fd
    );
  }

  public updatePlacaData(idPetition: string, release: string) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_release", release);

    return this.httpClient.put<any>(
      `${this.env}${this.tramitacionURL}placa/edit/tramitacion/placaIndividual/actualizarDatosPlaca`,
      {},
      { params: params }
    );
  }

  public assignImagePlaca(imgPlaca: ImgPlacaRequest) {
    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}placa/edit/Certificado/asignarNuevaImagenPlaca`,
      imgPlaca
    );
  }

  public getHistoricoBastidor(bastidor: string) {
    return this.httpClient.get<any>(
      `${this.env}${this.historicoBastidorURL}/edit/${bastidor}`
    );
  }

  public copyImagePlaca(imgPlaca: ImgPlacaRequest) {
    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}placa/edit/tramitacion/placaIndividual/copiarImagenPlaca`,
      imgPlaca
    );
  }

  public createImagePlaca(createImgPlaca: CreateImgPlacaRequest) {
    return this.httpClient.post<any>(
      `${this.env}${this.tramitacionURL}placa/edit/tramitacion/placaIndividual/nuevaImagenPlaca`,
      createImgPlaca
    );
  }

  public updatedDatosPlaca(idPetition: string, release: string) {
    let params = new HttpParams();
    params = params.append("_identificador", idPetition);
    params = params.append("_release", release);
    return this.httpClient.put<any>(
      `${this.env}${this.tramitacionURL}placa/edit/tramitacion/placaIndividual/actualizarDatosPlaca`,
      {},
      { params: params }
    );
  }

  /*Start services of Query*/

  public getDetailQuery(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.placaURL}consulta/detail`,
      {
        params: params,
      }
    );
  }

  public getListQuery(filters: string): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.placaURL}consulta/list${filters}`
    );
  }

  public getHistoryDetail(id: string): Observable<any> {
    let params = new HttpParams().set("idSolicitud", id);
    return this.httpClient.get<any>(
      `${this.env}${this.placaURL}consulta/historyDetail`,
      {
        params: params,
      }
    );
  }

  public getHistorylist(filters: string): Observable<ResponsesPageables> {
    return this.httpClient.get<ResponsesPageables>(
      `${this.env}${this.placaURL}consulta/historyList${filters}`
    );
  }

  public editarPrecio(peId: string, pePrecio: string)
  {
    const fd = new FormData();
    fd.append("_peId", peId);
    fd.append("_pePrecio", pePrecio);
    return this.httpClient.put<any>(
      `${this.env}${this.placaURL}edit/precio`,
      fd
    );
  }

  /*End services of Query*/
}
